<template>


  <div class="container">
    <div class="handle-box-search" style="height: auto;">

      <el-row class="head-search">



        <el-col :span="8">
          <span class="title">城市小组名称:</span>
          <!-- 搜索城市名 -->
          <el-input v-model="search_data.name" placeholder="请输入城市小组名称" class="handle-input mr10"
            @keyup.enter.native="searchCityLists"></el-input>

        </el-col>

        <el-col :span="24" style="margin: 10px 0;">
          <span class="title">状态 : </span>
          <el-radio-group v-model="search_data.status" size="small">
            <el-radio label="" border>全部</el-radio>
            <el-radio label="1" border>已开启</el-radio>
            <el-radio label="0" border>未开启</el-radio>
          </el-radio-group>
        </el-col>


      </el-row>


      <el-button type="primary" icon="el-icon-search" @click="searchCityLists">搜索</el-button>
      <el-button @click="add_isShow=!add_isShow">添加</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>



    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%;">


      <el-table-column prop="id" label="id" width="80">
      </el-table-column>

      <el-table-column prop="city.name" label="城市名称" width="300">


      </el-table-column>

      <el-table-column prop="name" label="小组名称">
      </el-table-column>

      <el-table-column prop="status.alias" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'danger':(scope.row.status.val=='1'?'':'warning')">
            {{scope.row.status.alias}}</el-tag>

        </template>
      </el-table-column>



      <el-table-column prop="time_simple" label="创建时间">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>详细时间: {{ scope.row.time.YmdHis }}</p>
            <div slot="reference">
              <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.time.Ymd}}
              </el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>


      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-button type="primary"
            @click="edit_isShow = !edit_isShow; edit_dialog_data = scope.row.city_group.city_group_code ">
            编辑


          </el-button>



        </template>
      </el-table-column>

    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>


    <!-- 对话框组件 -->
    <addCityTeamDialog :isShow="add_isShow" :data="options_city_code" @onSubmit="cityLists">
    </addCityTeamDialog>


    <editCityTeamDialog :isShow="edit_isShow" :data="options_city_code" :editcode="edit_dialog_data"
      @onSubmit="cityLists">
    </editCityTeamDialog>

    <editCompanyDialog :isShow="edit_company_isShow" :data="edit_company_dialog_data" @onSubmit="cityLists">
    </editCompanyDialog>
  </div>


</template>

<script>
  var _this;
  let options_city_code = []
  import addCityTeamDialog from './addCityTeamDialog.vue'
  import editCityTeamDialog from './editCityTeamDialog.vue'
  import editCompanyDialog from '../company/editCompanyDialog.vue';
  export default {
    components: {
      addCityTeamDialog,
      editCityTeamDialog,
      editCompanyDialog
    },
    data() {
      return {
        city_name: "",
        city_options_data: {
          page: 1,
          limit: 50,
          name: ''
        },
        options_city_code: [],

        add_city_data: {
          city_code: '',
          name: ''
        },


        more_search: false,
        // 传入子组件的数据
        edit_company_dialog_data: '',
        edit_dialog_data: '',

        // 对话框开关
        edit_isShow: false,
        edit_company_isShow: false,
        add_isShow: false,

        // 下拉列表
        options_company_code: [],
        company_options_data: {
          page: 1,
          limit: 50,
          name: ''
        },

        value_company_code: '',

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          name: '',
          status: '',


        },

        result_data: [],

        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },
          // name: {
          //   placeholder: '搜索的角色名称',
          //   rules: {
          //     required: false,
          //     message: '角色名称需在10汉字之内',
          //     regulation: 'elt_str',
          //     rulesData: 30
          //   }
          // }
        },

        // 存放点击操作按钮后的数据，用于传给对话框子组件
        city_data: [],
      };
    },
    created() {
      _this = this;
      _this.cityLists();



    },

    methods: {





      searchCityLists() {
        _this.search_data.page = 1;
        _this.cityLists();
      },
      toRouter(city_code, path) {

        this.$router.push({
          path: path,
          query: {
            city_code: city_code
          }
        })

      },
      // 公司下拉选中触发
      companyChange(val) {
        // 将选中城市的城市赋值给search_data用作搜索提交
        _this.search_data.company_code = val;

      },




      //搜索公司列表
      cityLists() {
        console.log(_this.search_data)
        _this.$post(
            "/city/cityGroupLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {


            // 将请求的数据存放到表格数据数组中
            _this.result_data = res;
            _this.tableData = res.data
          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.cityLists();

      },
      // 刷新按钮
      refresh() {
        this.$router.go(0);
      }
    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }
</style>